export default {
  GENERAL_ADMIN: 'GeneralAdministrator',
  ADMINISTRATOR: 'Administrator',
  INSTRUCTOR: 'Instructor',
  LEADER_USER: 'Leader'
}
